import { Component } from '@angular/core';

@Component({
  selector: 'app-assessment-add.component',
  imports: [],
  templateUrl: './assessment-add.component.html',
  styleUrl: './assessment-add.component.scss'
})
export class AssessmentAddComponent {

}
